export default __webpack_public_path__ + "static/media/logo.ce868d7f.png";